import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      toast.success('Welcome back!');
      navigate('/organizer/dashboard');
    } catch (e) {
      toast.error(e.response?.data?.error || 'Login failed');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg,#1A2744,#2D3A5F)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ background: '#fff', borderRadius: 20, padding: 40, maxWidth: 420, width: '100%', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <img src="https://omogusiiwarriors.org/icons/logo.png" alt="OWW" style={{ width: 70, height: 70, objectFit: 'contain', marginBottom: 12 }} />
          <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 24, color: '#1A2744', margin: '0 0 4px' }}>Tikoo Organizer</h1>
          <p style={{ color: '#9CA3AF', margin: 0, fontSize: 14 }}>Sign in to manage your events</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Email</label>
            <input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})}
              style={{ width: '100%', padding: '12px 14px', border: '1px solid #D1D5DB', borderRadius: 8, fontSize: 15, boxSizing: 'border-box' }}
              placeholder="your@email.com" required />
          </div>
          <div style={{ marginBottom: 8 }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Password</label>
            <input type="password" value={form.password} onChange={e => setForm({...form, password: e.target.value})}
              style={{ width: '100%', padding: '12px 14px', border: '1px solid #D1D5DB', borderRadius: 8, fontSize: 15, boxSizing: 'border-box' }}
              placeholder="••••••••" required />
          </div>
          <div style={{ textAlign: 'right', marginBottom: 20 }}>
            <Link to="/organizer/forgot-password" style={{ fontSize: 13, color: '#E8521A', fontWeight: 600 }}>Forgot password?</Link>
          </div>
          <button type="submit" disabled={loading}
            style={{ width: '100%', background: '#E8521A', color: '#fff', padding: 14, borderRadius: 10, border: 'none', fontWeight: 700, fontSize: 16, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}>
            {loading ? '⏳ Signing in...' : 'Sign In'}
          </button>
        </form>
        <p style={{ textAlign: 'center', marginTop: 20, fontSize: 14, color: '#6B7280' }}>
          No account? <Link to="/organizer/register" style={{ color: '#E8521A', fontWeight: 600 }}>Register here</Link>
        </p>
        <p style={{ textAlign: 'center', marginTop: 8, fontSize: 13 }}>
          <Link to="/" style={{ color: '#9CA3AF' }}>← Back to events</Link>
        </p>
      </div>
    </div>
  );
}
